

<template>
  <div class="StreamPlayer">
      
    <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.css" />
    
    <button class="button" @click="togglePlayback()">
      <span v-if="soundStatus=='playing'" class="playing"><i class="fa fa-volume-up fa-fw fa-lg"></i> Listening</span>
      <span v-if="soundStatus=='connecting'" class="loading"><i class="fa fa-spin fa-circle-o-notch fa-fw"></i> Connecting</span>
      <span v-if="soundStatus=='starting'" class="loading"><i class="fa fa-spin fa-spinner fa-fw fa-lg"></i> Starting</span>
      <span v-if="soundStatus=='listen'" class="listen"><i class="fa fa-volume-down fa-fw fa-lg"></i> Listen</span>
      <!-- <span v-if="soundStatus=='error'" class="error"><i class="fa fa-error">Error</i></span> -->
      <!-- <span v-if="soundStatus=='stream-error'" class="error"><i class="fa fa-error">Stream Error</i></span> -->
    </button>

    <!--<span v-text="streamAddress"></span>-->

  </div>
</template>

<script>

import axios from 'axios';
import Howler from 'howler';

export default {
  name: 'page-remote-control',
  props: ['instance', 'stream-address', 'addresses'],
  data() {
    return {
      sound: null,
      soundStatus: 'listen',
      intervals: {
        checkIcecast: null
      },
      icecast: {
        connectionChecks: 0,
        connectionChecksMax: 30,
      }
    };
  },
  watch: {
    instance(newVal, oldVal) { // watch it
      // console.log('Prop changed: ', newVal.name);
      // console.log('Was: ', oldVal.name);
    },
    streamAddress(newVal, oldVal) { // watch it
      
      // console.log('Prop changed: ', newVal);
      // console.log('Was: ', oldVal);
      
      // If already playing, then restart with new address.
      if (this.soundStatus == 'playing') {
        
        this.stopPlayback(() => {

          this.startPlayback()

        })

      }

    },
  },
  methods: {

    connectIcecast(callback = null) {

      callback = callback || function(){}

      let parentThis = this

      const URL = parentThis.addresses.audioServer
        + '/instances/' + parentThis.instance.name
        + '/outputs/stream-1'

      const data = {
        shouldConnect: true
      }

      axios.patch(URL, data)
        .then(() => {

          callback()
        
        })
        .catch(() => {

          X('could not connect to server')

          callback()
        
        })

    },

    stopConnectingIcecast(){

      console.log('attempting to stop connecting')

      // Make sure to stop the connection check interval.
      if(this.intervals.checkIcecast){
        
        console.log('stopped connecting')

        clearInterval(this.intervals.checkIcecast)

        this.intervals.checkIcecast = null

      }else{

        console.log('no interval')

      }

    },

    disconnectIcecast(callback = null) {

      callback = callback || function(){}

      // TODO: Fully remove this disconnection thing. 
      //       Not needed for Studio.
      return callback()

      this.stopConnectingIcecast()

      let parentThis = this

      const URL = parentThis.addresses.audioServer
        + '/instances/' + parentThis.instance.name
        + '/outputs/stream-1'

      const data = {
        shouldConnect: false
      }

      axios.patch(URL, data)
        .then(() => {

          callback()
        
        })
        .catch(() => {

          callback()
        
        })

    },

    checkIcecastConnected(resolve, reject){

      let parentThis = this

      const URL = parentThis.addresses.audioServer
        + '/instances/' + parentThis.instance.name
        + '/outputs/stream-1'
      
      console.log('checking: ' + URL)

      console.log(resolve)

      const response = axios.get(URL)

        .then((response) => {

          console.log(response.data)

          console.log("derp")
          console.log(resolve)

          // Resolve if it says "connected" in AudioServer response.
          if(response.data && response.data.status == "connected"){
            
            console.log("it's connected")

            parentThis.stopConnectingIcecast()
            
            return resolve()

          }else{
            
            parentThis.icecast.connectionChecks++
          
          }

          // Reject if it takes too long.
          if(
            parentThis.icecast.connectionChecks 
            > parentThis.icecast.connectionChecksMax
          ){

            console.log('taking too long')

            parentThis.stopConnectingIcecast()

            return reject()

          }

        })

    },

    waitUntilIcecastIsConnected(){

      this.icecast.connectionChecks = 0

      let parentThis = this

      return new Promise((resolve, reject) => {

        // Check for connection at AudioServer.
        parentThis.intervals.checkIcecast = setInterval(
          function() { 
          // function(resolve, reject) { 
            parentThis.checkIcecastConnected(resolve, reject)
          },
          500
        )
      
      })

    },

    startPlayback(callback = null) {

      callback = callback || function(){}

      let parentThis = this

      parentThis.soundStatus = 'connecting';

      this.connectIcecast()

      // Connect the Icecast stream.
      this.waitUntilIcecastIsConnected()

        .then(() => {

          parentThis.soundStatus = 'starting';

          // Make sure that createSound() is available.
          if (parentThis.createSound) {

            parentThis.createSound();

            if (parentThis.sound && parentThis.sound.play) {

              parentThis.sound.play();

            }
          
          }

          return callback()

        })
        .catch((error) => {
          
          console.log("Could not connect:")
          console.log(error)

          alert('Audio stream took too long to connect.')

          parentThis.stopPlayback()

          return callback()

        })

    },

    stopPlayback(callback = null) {

      callback = callback || function(){}

      let parentThis = this

      if(this.sound && this.sound.stop){

        // Stop audio.
        this.sound.stop()
        
        // Totally unload it so that there aren't any fragments of Howler state.
        this.sound.unload()

      }

      // Disconnect Icecast at the AudioServer.
      this.disconnectIcecast(function(){
        
        parentThis.soundStatus = 'listen'

        callback()

      })

    },

    togglePlayback() {
      if (this.soundStatus == 'listen') {
        this.startPlayback()
      } else {
        this.stopPlayback()
      }
    },

    createSound() {
      console.log(`Loaded stream address: ${this.streamAddress}`);

      if (!this.streamAddress) {
        console.log('ERROR: No stream address loaded.');
      }

      this.sound = new Howl({
        src: [this.streamAddress],
        html5: true, // A live stream can only be played through HTML5 Audio.
        format: ['mp3'],
      });

      const _this = this;

      // Fires when the sound finishes playing.
      // this.sound.on('load', function(){
      //   _this.soundStatus = 'playing'
      //   console.log('Loaded.');
      // });

      // Fires when the sound finishes playing.
      this.sound.on('loaderror', () => {
        _this.soundStatus = 'error';
        console.log('Error while loading.');
      });

      // Fires when the sound finishes playing.
      this.sound.on('play', () => {
        _this.soundStatus = 'playing';
        console.log('Playing.');
      });

      // Fires when the sound finishes playing.
      this.sound.on('end', () => {
        _this.soundStatus = 'listen';
        console.log('End.');
      });

      // Fires when the sound finishes playing.
      this.sound.on('pause', () => {
        _this.soundStatus = 'listen';
        console.log('Pause.');
      });

      // Fires when the sound finishes playing.
      this.sound.on('stop', () => {
        _this.soundStatus = 'listen';
        console.log('Stop.');
      });

      // All events:
      // load, loaderror, playerror, play, end, pause, stop,
      // mute, volume, rate, seek, fade, unlock

      return true;
    },

  },

  beforeDestroy() {
    
    this.stopPlayback()

    clearInterval(this.intervals.checkIcecast)

    return true

  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="stylus" scoped>

  .StreamPlayer

    h1 
      font-size: 30px; 
      margin: 0 0 20px 0;

    
    button 
      background-color: #fff; 
      border-radius: 6px; 
      padding: 8px 10px; 
      margin:0; 
      color: #000; 
      font-size: 16px; 
      font-weight 600
      border: 2px solid #ddd; 
    

</style>
